import { loadStripe } from '@stripe/stripe-js'

export const state = () => ({
  stripeObject: {
    stripe: null,
    elements: null,
    card: null,
    errorMessage: ''
  }
})

export const mutations = {
  SET_STRIPE(state, stripe) {
    state.stripeObject.stripe = stripe
  },
  SET_ELEMENTS(state, elements) {
    state.stripeObject.elements = elements
  },
  SET_CARD(state, card) {
    state.stripeObject.card = card
  },
  SET_ERROR_MESSAGE(state, message) {
    state.stripeObject.errorMessage = message
  }
}

export const actions = {
  async initializeStripe({ commit }) {
    // const stripe = await loadStripe(
    //   'pk_live_51KtAj1Ap7kKT81Plxl3n3jZ90bHlWM5t3ZAvU82uNsn74HsCJKytumtc4wMna6RCXp137SdT6AC5etqBl2taFpFu00Dy3FCkhX'
    // )
        const stripe = await loadStripe(
      'pk_test_51KtAj1Ap7kKT81PlNp81akAy3fgx8QYYVkgAYhYh25hpQwhu5NC3rdaINqlPJ6iAFaPd0DVRDs8PjcsyfQZ20fO000uu3Ad7Bn'
    )
    const elements = stripe.elements()
    const card = elements.create('card')
    commit('SET_STRIPE', stripe)
    commit('SET_ELEMENTS', elements)
    commit('SET_CARD', card)
  },
  setErrorMessage({ commit }, message) {
    commit('SET_ERROR_MESSAGE', message)
  }
}

export const getters = {
  stripeObject: state => state.stripeObject,
  amount: state => state.amount,
  errorMessage: state => state.stripeObject.errorMessage
}

export default {
  namespaced: true, // optional, if you want namespacing
  state,
  mutations,
  actions,
  getters,
};
